module.exports = __webpack_public_path__ + "img/m-icon-s-house.a41cd6ac.png";